import React from 'react';
import { SpecialistIcon } from './specialistIcons';
import type { MemberSpec } from './types';
import { TYPE } from '../../constants/typeScale';

/** A row of animated dots. */
const Dots: React.FC = () => (
  <span className="flex gap-1">
    <span className="w-1.5 h-1.5 rounded-full bg-secondary-400 animate-bounce [animation-delay:-0.3s]" />
    <span className="w-1.5 h-1.5 rounded-full bg-secondary-400 animate-bounce [animation-delay:-0.15s]" />
    <span className="w-1.5 h-1.5 rounded-full bg-secondary-400 animate-bounce" />
  </span>
);

/**
 * One "typing…" row per specialist currently composing a reply — so the user sees
 * each member responding individually, mirroring how their bubbles will land.
 */
const TypingIndicator: React.FC<{ members: MemberSpec[] }> = ({ members }) => {
  if (!members.length) return null;
  return (
    <div className="space-y-3">
      {members.map((m) => (
        <div key={m.id} className="flex gap-3" data-testid={`typing-${m.id}`}>
          <div className="w-8 h-8 rounded-full bg-secondary-100 dark:bg-secondary-800 flex items-center justify-center shrink-0">
            <SpecialistIcon name={m.avatar_icon} className="w-4 h-4 text-secondary-600 dark:text-secondary-300" />
          </div>
          <div className="flex items-center gap-2 rounded-2xl rounded-tl-sm px-4 py-2.5 bg-secondary-100 dark:bg-secondary-800">
            <span className={`${TYPE.control} font-medium text-secondary-500`}>{m.name}</span>
            <span className={`${TYPE.control} text-secondary-400`}>typing</span>
            <Dots />
          </div>
        </div>
      ))}
    </div>
  );
};

export default TypingIndicator;
